import React from "react";
import {
  Card,
  CardContent,
  Chip,
  Grid,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import {
  formatCurrency,
  formatDate,
  getBillStatusDisplay,
} from "../utils/accountsHelpers";

const BillList = ({ bills = [], onEdit }) => {
  if (!bills.length)
    return <Typography color="text.secondary">No bills found.</Typography>;

  return (
    <Grid container spacing={2}>
      {bills.map((bill) => {
        const status = getBillStatusDisplay(bill.status);
        return (
          <Grid item xs={12} md={6} lg={4} key={bill.id}>
            <Card>
              <CardContent>
                <Typography variant="h6">{bill.billNumber}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {bill.vendorSnapshot?.name || "No vendor"}
                </Typography>
                <Stack direction="row" spacing={1} sx={{ my: 1 }}>
                  <Chip
                    label={status.label}
                    color={status.color}
                    size="small"
                  />
                </Stack>
                <Typography variant="body2">
                  Bill Date: {formatDate(bill.billDate)}
                </Typography>
                <Typography variant="body2">
                  Due Date: {formatDate(bill.dueDate)}
                </Typography>
                <Typography variant="body1" sx={{ mt: 1, fontWeight: 600 }}>
                  {formatCurrency(bill.totals?.grandTotal || 0)}
                </Typography>
                <Button
                  sx={{ mt: 2 }}
                  size="small"
                  variant="outlined"
                  onClick={() => onEdit?.(bill)}
                >
                  Edit
                </Button>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default BillList;
